import { createFileRoute, notFound } from '@tanstack/react-router'
import { NetworkCorridorDetail } from '@/components/sensnet/networkCorridors/NetworkCorridorDetail'

export const Route = createFileRoute('/sensnet/network-corridors/$corridorNumber')({
  staticData: {
    title: 'Network Corridor Profile',
    isSecured: true,
  },
  parseParams: (params) => ({
    corridorNumber: Number(params.corridorNumber),
  }),
  beforeLoad: ({ params }) => {
    if (isNaN(params.corridorNumber)) throw notFound()
  },
  component: NetworkCorridorProfilePage,
})

function NetworkCorridorProfilePage() {
  const { corridorNumber } = Route.useParams()
  return (
    <div className="p-6">
      <NetworkCorridorDetail corridorNumber={corridorNumber} />
    </div>
  )
}
